import { hasPro } from "../lib/pro";

// Dashboard is part of the paid Pro package.
export function isDashboardEnabled(user) {
  return hasPro(user);
}

// Company users with Pro (manager/office) see the dashboard summary; super admins pick a company first.
export function canSeeDashboard(user) {
  return user?.pro_package === true && ["manager", "office"].includes(user?.role);
}
